import { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

const CabinSuiteSection = lazy(() => import('../CabinSuiteSection'));

const CabinSuiteSectionLazy = () => {
  return (
    <Suspense 
      fallback={
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="600px"
          sx={{ backgroundColor: '#FFF5F5' }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <CabinSuiteSection />
    </Suspense>
  );
};

export default CabinSuiteSectionLazy;
